<template>
  <div class="bgfff out_wrap">
    <div class="errPage-container">
      <el-row>
        <el-col :span="12">
          <div class="text-jumbo text-ginormous">出错了!</div>
          <div class="tit-des">你没有权限去该页面</div>
          <div class="sub-tit-des">如有不满请联系系统管理员</div>
          <el-button icon="el-icon-arrow-left" class="pan-back-btn" @click="back">
            返回
          </el-button>
        </el-col>
        <el-col :span="12">
          <img :src="errGif" width="313" height="428" alt="Girl has dropped her ice cream.">
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import errGif from '@/assets/401_images/401.gif'
export default {
  name: 'Page401',
  data() {
    return {
      errGif: errGif + '?' + +new Date()
    }
  },
  methods: {
    back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: '/home' })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .errPage-container {
    width: 800px;
    max-width: 100%;
    margin: 100px auto;
    .pan-back-btn {
      background: #1482f0;
      color: #fff;
      border: none!important;
      margin-top: 30px;
    }
    .pan-gif {
      margin: 0 auto;
      display: block;
    }
    .pan-img {
      display: block;
      margin: 0 auto;
      width: 100%;
    }
    .text-jumbo {
      font-size: 32px;
      font-weight: 700;
      color: #1482f0;
      margin-top: 20px;
    }
    .tit-des{
      font-size: 20px;
      line-height: 24px;
      color: #222;
      font-weight: bold;
      margin-top: 20px;
    }
    .sub-tit-des{
      font-size: 13px;
      line-height: 21px;
      color: grey;
      margin-top: 20px;
    }
  }
</style>
